// T-058 Stufe 2 (v1.8.61, Session 46, 07.10.2026): Zubuchungsart je Tour-Konfiguration ("Online-Angebot") für die Verwaltung
// (TourTypeAddonConfig.tsx) und das Gast-Buchungsfenster (ImprovedBookingModal.tsx). Gleiche Regeln wie der Server
// (Business.Buchung.Zubuchung): "Automatisch" gewinnt, "Optional zubuchbar" erscheint online mit Menge 0, "Nur Verwaltung" nicht online.
// Reine Funktionen, getestet in zubuchung.test.ts.

export type OnlineAngebot = 'automatisch' | 'optional' | 'verwaltung';

export interface ZubuchungFelder {
  isAutoAdd: boolean;
  isOptionalExtra: boolean;
}

export const ONLINE_ANGEBOT_OPTIONEN: ReadonlyArray<{ wert: OnlineAngebot; text: string; hinweis: string }> = [
  {
    wert: 'automatisch',
    text: 'Automatisch vorbelegt',
    hinweis: 'Menge aus der Teilnehmerzahl, z. B. Inklusivgerichte (wie bisher "Automatisch bei Buchung hinzufügen")',
  },
  {
    wert: 'optional',
    text: 'Optional zubuchbar (Menge 0, Gast wählt)',
    hinweis: 'Gast und Verwaltung sehen die Leistung beim Buchen und im Kundenkonto mit Menge 0, berechnet nur bei Auswahl',
  },
  {
    wert: 'verwaltung',
    text: 'Nur Verwaltung',
    hinweis: 'nicht im Online-Angebot, die Verwaltung fügt sie in "Buchung bearbeiten" hinzu',
  },
];

/** Auswahl aus den gespeicherten Feldern; "Automatisch" gewinnt (wie der Server). */
export function onlineAngebotVon(f: { isAutoAdd?: boolean | null; isOptionalExtra?: boolean | null }): OnlineAngebot {
  if (f.isAutoAdd) return 'automatisch';
  if (f.isOptionalExtra) return 'optional';
  return 'verwaltung';
}

/** Felder für die API aus der Auswahl (nie beide gesetzt). */
export function felderVon(angebot: OnlineAngebot): ZubuchungFelder {
  return { isAutoAdd: angebot === 'automatisch', isOptionalExtra: angebot === 'optional' };
}

/** Abzeichen in der Liste der Konfigurationen. */
export function abzeichen(angebot: OnlineAngebot): string {
  switch (angebot) {
    case 'automatisch': return 'Auto-Add';
    case 'optional': return 'Optional';
    default: return 'Nur Verwaltung';
  }
}

/**
 * true, wenn die Konfiguration im Online-Angebot steht (Automatisch oder Optional). Review v1.8.61: eine nicht (mehr) zulässige
 * "Optional zubuchbar"-Konfiguration (Server-Merkmal optionalUnzulaessig) bleibt draußen, wie im calculate des Servers.
 */
export function imOnlineAngebot(f: { isAutoAdd?: boolean | null; isOptionalExtra?: boolean | null; optionalUnzulaessig?: boolean | null }): boolean {
  const angebot = onlineAngebotVon(f);
  if (angebot === 'optional' && f.optionalUnzulaessig) return false;
  return angebot !== 'verwaltung';
}

/**
 * Hinweis der Oberfläche, warum "Optional zubuchbar" nicht passt (der Server prüft zusätzlich Wahlgericht, Unterkunft, Kurtaxe,
 * Nur Backoffice und den Namen), sonst null.
 */
export function optionalHinweis(isIncludedInTourPrice: boolean, includedQuantity: number, priceOverride?: number | null): string | null {
  if (isIncludedInTourPrice || (includedQuantity || 0) > 0) {
    return 'Optional zubuchbar sind nur kostenpflichtige Leistungen: Preisgestaltung "Zusätzlich berechnen" und Inklusiv-Menge 0.';
  }
  if (priceOverride !== undefined && priceOverride !== null && !Number.isNaN(priceOverride)) {
    return 'Ein Preis-Override wirkt online nicht: Preis-Override leer lassen und den Preis in der Zusatzoption pflegen.';
  }
  return null;
}
